import { HEALTH_CONFIG } from '../config/healthConfig';

function getChileParts(now = new Date()) {
  const df = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Santiago',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    hour12: false,
  });
  const parts = Object.fromEntries(df.formatToParts(now).map(p => [p.type, p.value]));
  return {
    year: Number(parts.year),
    month: Number(parts.month),
    day: Number(parts.day),
    hour: Number(parts.hour),
  };
}

function formatYMD({ year, month, day }) {
  return `${String(year).padStart(4,'0')}-${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
}

function subDaysYMD(ymd, days) {
  let { year, month, day } = ymd;
  let n = Number(days) | 0;
  const daysInMonth = (y, m) => new Date(Date.UTC(y, m, 0)).getUTCDate();
  while (n > 0) {
    if (day > 1) { day--; n--; }
    else { month--; if (month === 0) { month = 12; year--; } day = daysInMonth(year, month); n--; }
  }
  return { year, month, day };
}

export function businessDateChile06(now = new Date()) {
  const parts = getChileParts(now);
  if (!HEALTH_CONFIG.CUTOFF_06_ENABLED) return formatYMD(subDaysYMD(parts, 1));
  const daysBack = parts.hour < 6 ? 2 : 1;
  return formatYMD(subDaysYMD(parts, daysBack));
}

export function todayChile(now = new Date()) {
  return formatYMD(getChileParts(now));
}


